module.exports = __webpack_public_path__ + "img/bg1536.80b20fff.png";